import React from 'react';
import Card from '@/components/ui/cards/Card';
import CardHeader from '@/components/ui/cards/CardHeader';
import CardBody from '@/components/ui/cards/CardBody';
import { Link } from 'react-router-dom';
import Pagination from '@/components/ui/tables/Pagination';
import TablePagination from '@/components/ui/tables/TablePagination';

const RoleDataTable = ({ dataSource, handleModelOpen, deleteRecord }) => {
    return (
        <>
            <ul>
                {dataSource.map((role, index) => (
                    <li key={index} className="flex flex-col items-center justify-between gap-4 sm:flex-row sm:justify-between py-3 px-4 border-b last:border-none border-solid border-slate-200">
                        <span className="font-medium capitalize text-center sm:text-left text-sm text-slate-500">
                            {role.name}
                            <span className="block font-normal whitespace-nowrap">({role.value == 'admin' ? 1 : role.adminCount}) Members</span>
                        </span>
                        <div className="flex flex-wrap justify-center items-center sm:items-start sm:justify-end gap-1.5">
                            {role.value != 'admin' ? (
                                <>
                                    <Link to={'/admin/settings/role/' + role._id} className="db-btn-outline sm primary modal-btn m-0.5">
                                        <i className="lab lab-key"></i>
                                        <span>permissions</span>
                                    </Link>
                                    <button className="db-btn-outline sm success modal-btn m-0.5" onClick={() => handleModelOpen(role._id)}>
                                        <i className="lab lab-edit-line"></i>
                                        <span>edit</span>
                                    </button>
                                    <button className="db-btn-outline sm danger modal-btn m-0.5" onClick={() => deleteRecord(role._id)}>
                                        <i className="lab lab-delete"></i>
                                        <span>delete</span>
                                    </button>
                                </>
                            ) : (
                                <></>
                            )}
                        </div>
                    </li>
                ))}
            </ul>
            <TablePagination />
        </>
    );
};

export default RoleDataTable;
